import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import { verifyToken } from "../utils/VerifyToken";
import { checkForAuthorization } from "utils/index";

// Changes the email on a startup/investor and its login user. The backend also
// clears any bounce flag on the new address, which is how admin de-flags one.
export const UpdateUserEmail = () => {
    return useMutation(
        ({ entity, id, email }) => {
            return axios({
                method: 'put',
                url: `${process.env.REACT_APP_BASE_URL}/email-bounces/update-email`,
                data: { entity, id, email },
                headers: {
                    Authorization: `Bearer ${checkForAuthorization()}`,
                    'Content-type': 'application/json'
                },
            });
        },
        {
            retry: 0,
            onError: (err) => {
                return verifyToken(err);
            }
        }
    );
};
